<template>
  <div>
    <Mobilenav></Mobilenav>
    <div class="navigate-steps offset-1 col-10 row d-none d-lg-flex mb-3" v-if="$store.state.showNavigation"
        role="progressbar"
        aria-valuemin="0"
        :aria-valuenow="this.$store.getters.activeStepsArray.filter( step => isFinished(step.index) ).length"
        :aria-valuemax="this.$store.getters.activeStepsArray.length"
        aria-label="Fortschritt"
    >
      <template v-for="(step, idx) in this.$store.getters.activeStepsArray">
        <div class="navigate-step"
          :class="{ active: isActive(step.index), finished: isFinished(step.index) }"
        >
          <component :is="isFinished(step.index) ? 'a' : 'div'" :href="isFinished(step.index) ? '#' : null"
                     @click.prevent="clickStep(step.index)" :aria-labelledby="`nav-step-${idx}`">
            <span class="step-number user-select-none">
                <span class="text">
                    {{ idx + 1 }}
                </span>
                <i :class="`${$store.state.faClass} fa-check`" aria-hidden="true"></i>
            </span>
          </component>
          <div class="title" :id="`nav-step-${idx}`">
            {{ step.title }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Mobilenav from './partials/Mobilenav'

export default {
  components: {
    Mobilenav,
  },
  methods: {
    clickStep(index) {
      this.$store.commit('reverseDirection', true);
      if (index < this.$store.state.currentStepIndex) {
        this.$store.state.currentStepIndex = index;
      }
    },

    isActive(index) {
      return index === this.$store.state.currentStepIndex;
    },

    isFinished(index) {
      return index < this.$store.state.currentStepIndex;
    }
  },
}
</script>
